var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-body-2 ma-0"},[(_vm.report.institution)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.report.institution)}}):_vm._e(),_vm._v(", \n  "),(_vm.year==2100)?_c('span',[_vm._v(", to appear")]):_vm._e(),_vm._v(" "),(_vm.year < 2100)?_c('span',[_vm._v(_vm._s(_vm.year))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }